<!-- eslint-disable max-len -->
<template>
<svg
    width="32" height="32" viewBox="0 0 32 32"
    fill="none" xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M15.9993 22.6667C16.7357 22.6667 17.3327 22.0697 17.3327 21.3333C17.3327 20.597 16.7357 20 15.9993 20C15.263 20 14.666 20.597 14.666 21.3333C14.666 22.0697 15.263 22.6667 15.9993 22.6667Z" fill="currentColor"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M25.3333 13.334H6.66667C5.19391 13.334 4 14.5279 4 16.0007V26.6673C4 28.1401 5.19391 29.334 6.66667 29.334H25.3333C26.8061 29.334 28 28.1401 28 26.6673V16.0007C28 14.5279 26.8061 13.334 25.3333 13.334Z"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M9.33398 13.3327V9.33268C9.33398 7.56457 10.0364 5.86888 11.2866 4.61864C12.5368 3.36839 14.2325 2.66602 16.0007 2.66602C17.7688 2.66602 19.4645 3.36839 20.7147 4.61864C21.9649 5.86888 22.6673 7.56457 22.6673 9.33268V13.3327"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
</template>
